import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <div className="flex flex-col items-center justify-center min-h-[60vh] pt-20 px-4 text-center">
        <span className="w-20 h-20 flex items-center justify-center rounded-full bg-background-200 text-foreground-400 mb-6">
          <i className="ri-error-warning-line text-3xl"></i>
        </span>
        <h1 className="font-heading text-2xl font-bold text-foreground-900 mb-3">页面未找到</h1>
        <p className="text-foreground-500 text-sm mb-8">您访问的页面不存在或已被移除</p>
        <Link
          to="/"
          className="px-6 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap"
        >
          返回首页
        </Link>
      </div>
      <Footer />
    </div>
  );
}